<div class="container-fluid background-transparent pt-0">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
</div>

<div class="content-inner background-section">
  <div class="title-bar background-transparent">
    <a class="back-button mt-2 mb-4" (click)="emitData({key:'back'})"><img class="svg mr-2 ml-4 back-button"
        src="assets/ph-bhp-layout/svg/back.svg" /> {{ translationKeys.SOPObservation.Back | translate}}</a>
    <div class="container-fluid d-md-flex justify-content-between background-transparent">
      <h2 class="page-title">{{"EVALUATION.OVERVIEW_INDIVIDUAL_DATA_1" | translate}}</h2>
      <div>
        <lib-ph-bhp-observe-chart-export #exportTag [gridData]="gridData" [filter]="filter"
          [observationDetailsExcelFields]="observationDetailsExcelFields" [fields]="fields" [select]="'individualData'"
          (childData)="emitData($event)" [fileName]="pageTitle" [appName]="appName" [clickImageBtn]="clickImageBtn"
          [clickExcelBtn]="clickExcelBtn" [clickPdfBtn]="clickPdfBtn" [userData]="appConfig.userData"
          (resetClickBtn)="resetExportAs($event)" [clickDetailsExcelBtn]="clickDetailsExcelBtn"
          class="col p-0"></lib-ph-bhp-observe-chart-export>
      </div>
    </div>
  </div>
  <div class="evaluation-section container-fluid reportFiter">

    <div class="row">
      <div class="col my-3 d-flex  justify-content-end">
        <button class="btn-link-reset" (click)="resetFilters()" *ngIf="userHasFilter">{{ 'EVALUATION.RESET_FILTERS' | translate }}</button>
        <button class="btn-cancel-bordered-bd" (click)="openFilter()" *ngIf="!userHasFilter">{{ 'EVALUATION.ADD_FILTER' | translate }}</button>
      </div>
    </div>

    <div class="mt-4">

    </div>
    <lib-ph-bhp-filter #filter [userData]="userData" [evaluationLoaded]="evaluationLoaded"
      (filterSaved)="onFilterSaved()" [filterIndex]="0" [userHasFilter]="userHasFilter" [isMultiselectReport]="false"></lib-ph-bhp-filter>

    <div class="row justify-content-between">
      <div class="col my-3 d-flex justify-content-start" (click)="showDeleteSelectionModal()"  *ngIf="userHasFilter">
        <div>
          <img class="dropdown-arrow mr-2" src="assets/icons/trashDarkOutlined.svg" />
          <label class="selection-label">{{ 'EVALUATION.DELETE_SELECTION' | translate }}</label>
        </div>
      </div>

      <div class="col my-3 d-flex justify-content-end">
        <div class="dropdown dropdown-bhp">
          <div class="dropdown-container-input" [ngClass]="!userHasFilter ? 'disabled' : ''" data-toggle="dropdown"
            aria-expanded="false">
            <div class="d-flex align-items-center">
              <img class="dropdown-arrow mr-2"
                src="{{ !userHasFilter ? 'assets/icons/downloadDarkOutlined-disabled.svg' : 'assets/icons/downloadDarkOutlined.svg' }}" />
              <label [ngClass]="!userHasFilter ? 'disabled-export' : ''">{{ 'EVALUATION.EXPORT' | translate }}</label>
            </div>
            <img class="dropdown-arrow"
              src="{{ !userHasFilter ? 'assets/icons/arrowDropdownOutlined-disabled.svg' : 'assets/icons/arrowDropdownOutlined.svg' }}" />
          </div>

          <ul class="dropdown-menu">
            <li class="dropdown-item" *ngIf="gridData" (click)="excelDownload()">{{ 'GENERAL.EXCEL' | translate }}</li>
            <li class="dropdown-item" *ngIf="gridData" (click)="detailsExcelDownload()">{{
              'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_EXPORT' | translate }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-12 static-card first-card">
      <div class="row">
        <h1 class="section-title col-md-6">{{ 'EVALUATION.OVERVIEW_INDIVIDUAL_DATA_2' | translate }}</h1>
        <div [ngClass]="!noDataFound ? 'active-refresh' : 'inactive-refresh'"
          class="justify-content-end col-md-6 refresh-box" (click)="onRefreshClick(noDataFound)">
          <img *ngIf="!noDataFound" src="assets/ph-bhp-evaluation/icon-refresh-active.svg" />
          <img *ngIf="noDataFound" src="assets/ph-bhp-evaluation/icon-refresh-inactive.svg" />
          <span>{{ 'CONFIGURE.FILTERS.REFRESH' | translate }}</span>
        </div>
      </div>
      <bd-light-table #gridTable [gridData]="gridData || []" [pageInfo]="pageInfo" [fields]="fields"
        [isEvaluationTable]="isEvaluationTable" [actions]="actionItems" [isSelectable]="isSelectable"
        *ngIf="userHasFilter"></bd-light-table>
      <div class="no-data-box" *ngIf="!userHasFilter">
        <span class="no-data-text">{{ 'CONFIGURE.FILTERS.NO_FILTER_FOUND' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<ng-template #delmodal>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"> <img src="assets/ph-bhp-layout/svg/remove.svg">
    </a>
  </div>
  <div class="modal-body">
    <p> {{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD' | translate }} </p>
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
      <button (click)="delete();modalRef.hide()" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
    </div>
  </div>
</ng-template>

<ng-template #deleteSelectionModal>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"> <img src="assets/ph-bhp-layout/svg/remove.svg">
    </a>
  </div>
  <div class="modal-body">
    <p> {{ deleteSelectionText }} </p>
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
      <button (click)="deleteSelection();modalRef.hide()" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
    </div>
  </div>
</ng-template>